<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex flex-wrap align-center gap-3">
            <span>Dashboard</span>
            <v-spacer></v-spacer>
            <div class="d-flex flex-wrap gap-3">
              <v-text-field
                v-model="fechaInicio"
                type="date"
                label="Fecha inicio"
                density="compact"
                hide-details
                style="min-width: 160px"
              ></v-text-field>
              <v-text-field
                v-model="fechaFin"
                type="date"
                label="Fecha fin"
                density="compact"
                hide-details
                style="min-width: 160px"
              ></v-text-field>
              <v-btn color="primary" @click="cargarDashboard" :loading="loading">
                Actualizar
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text>
            <v-alert v-if="error" type="error" variant="tonal" class="mb-4">
              {{ error }}
            </v-alert>
            <v-row>
              <v-col cols="12" md="4">
                <v-card variant="tonal" color="primary">
                  <v-card-title class="text-subtitle-1">Total matrículas</v-card-title>
                  <v-card-text class="text-h4 font-weight-bold">
                    {{ totalMatriculas }}
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <v-card variant="outlined">
                  <v-card-title class="text-subtitle-1">Matrículas por rango</v-card-title>
                  <v-card-text>
                    <div v-if="matriculasDetalle.length" class="chart-panel">
                      <div ref="matriculasRangoChart" class="amchart"></div>
                    </div>
                    <div v-else class="text-caption text-grey">
                      No hay datos para el rango seleccionado.
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-subtitle-1">Matrículas por mes</v-card-title>
          <v-card-text>
            <div v-if="matriculasPorMes.length" class="chart-panel">
              <div ref="matriculasMesChart" class="amchart"></div>
            </div>
            <div v-else class="text-caption text-grey">
              No hay datos para el año seleccionado.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-subtitle-1">Total de matrículas por día</v-card-title>
          <v-card-text>
            <div v-if="promedioMatriculasPorDia.length" class="chart-panel">
              <div ref="promedioMatriculasChart" class="amchart"></div>
            </div>
            <div v-else class="text-caption text-grey">
              No hay datos disponibles.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-subtitle-1">Total de matrículas por hora</v-card-title>
          <v-card-text>
            <div v-if="promedioMatriculasPorHora.length" class="chart-panel">
              <div ref="promedioMatriculasHoraChart" class="amchart"></div>
            </div>
            <div v-else class="text-caption text-grey">
              No hay datos disponibles.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="text-subtitle-1">Matrículas por canal de atención</v-card-title>
          <v-card-text>
            <div v-if="matriculasPorCanal.length" class="chart-panel">
              <div ref="matriculasCanalChart" class="amchart amchart-pie"></div>
            </div>
            <div v-else class="text-caption text-grey">
              No hay datos para el rango seleccionado.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="text-subtitle-1">Cursos más matriculados</v-card-title>
          <v-card-text>
            <div v-if="cursosMasMatriculados.length" class="bar-list">
              <div
                v-for="curso in cursosMasMatriculados"
                :key="curso.id"
                class="bar-row"
              >
                <div class="bar-label">{{ curso.descripcion }}</div>
                <div class="bar-track">
                  <div class="bar-fill" :style="{ width: `${curso.porcentaje}%` }"></div>
                </div>
                <div class="bar-value">{{ curso.total }}</div>
              </div>
            </div>
            <div v-else class="text-caption text-grey">
              No hay cursos para mostrar.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="text-subtitle-1">Alumnos por edad y sexo</v-card-title>
          <v-card-text>
            <div v-if="edadesPorGenero.length" class="stacked-list">
              <div
                v-for="(grupo, index) in edadesPorGenero"
                :key="`${grupo.edad}-${index}`"
                class="stacked-row"
              >
                <div class="bar-label">{{ grupo.edad }} años</div>
                <div class="stacked-track">
                  <div
                    v-for="segmento in grupo.segmentos"
                    :key="segmento.genero"
                    class="stacked-segment"
                    :style="{
                      width: `${segmento.porcentaje}%`,
                      backgroundColor: segmento.color,
                    }"
                  ></div>
                </div>
                <div class="bar-value">{{ grupo.total }}</div>
              </div>
              <div class="legend">
                <div v-for="(color, genero) in generoColores" :key="genero" class="legend-item">
                  <span class="legend-dot" :style="{ backgroundColor: color }"></span>
                  <span>{{ genero }}</span>
                </div>
              </div>
            </div>
            <div v-else class="text-caption text-grey">
              No hay datos disponibles.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { defineComponent, ref, computed, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { useTheme } from 'vuetify'
import axios from 'axios'
import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import * as am5percent from '@amcharts/amcharts5/percent'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'
import am5themes_Responsive from '@amcharts/amcharts5/themes/Responsive'

const formatDateInput = (date) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

export default defineComponent({
  setup() {
    const loading = ref(false)
    const error = ref('')
    const matriculasDetalle = ref([])
    const matriculasPorMes = ref([])
    const totalMatriculas = ref(0)
    const cursosMasMatriculados = ref([])
    const alumnosEdadSexo = ref([])
    const promedioMatriculasPorDia = ref([])
    const promedioMatriculasPorHora = ref([])
    const chartRoot = ref(null)
    const chartInstance = ref(null)
    const chartSeries = ref(null)
    const chartAxes = ref({ xAxis: null, yAxis: null })
    const rangoRoot = ref(null)
    const rangoInstance = ref(null)
    const rangoSeries = ref(null)
    const rangoAxes = ref({ xAxis: null, yAxis: null })
    const promedioRoot = ref(null)
    const promedioInstance = ref(null)
    const promedioSeries = ref(null)
    const promedioAxes = ref({ xAxis: null, yAxis: null })
    const promedioHoraRoot = ref(null)
    const promedioHoraInstance = ref(null)
    const promedioHoraSeries = ref(null)
    const promedioHoraAxes = ref({ xAxis: null, yAxis: null })
    const matriculasPorCanal = ref([])
    const canalRoot = ref(null)
    const canalInstance = ref(null)
    const canalSeries = ref(null)
    const canalLegend = ref(null)
    const matriculasMesChart = ref(null)
    const matriculasRangoChart = ref(null)
    const promedioMatriculasChart = ref(null)
    const promedioMatriculasHoraChart = ref(null)
    const matriculasCanalChart = ref(null)
    const theme = useTheme()
    const isDark = computed(() => theme.global.current.value.dark)

    const today = new Date()
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1)

    const fechaInicio = ref(formatDateInput(startDate))
    const fechaFin = ref(formatDateInput(today))

    const BRAND_PRIMARY = '#f2cd14'
    const BRAND_SECONDARY = '#FFB300'

    const generoColores = computed(() => {
      const palette = [BRAND_PRIMARY, BRAND_SECONDARY, '#FB8C00', '#F57F17']
      const generos = [...new Set(alumnosEdadSexo.value.map((item) => item.genero))]
      return generos.reduce((acc, genero, index) => {
        acc[genero] = palette[index % palette.length]
        return acc
      }, {})
    })

    const edadesPorGenero = computed(() => {
      if (!alumnosEdadSexo.value.length) return []
      const grouped = alumnosEdadSexo.value.reduce((acc, item) => {
        const edad = item.edad
        if (!acc[edad]) acc[edad] = []
        acc[edad].push(item)
        return acc
      }, {})

      return Object.entries(grouped)
        .sort(([edadA], [edadB]) => Number(edadA) - Number(edadB))
        .slice(0, 12)
        .map(([edad, items]) => {
          const total = items.reduce((sum, item) => sum + item.total, 0)
          const segmentos = items.map((item) => ({
            genero: item.genero,
            total: item.total,
            porcentaje: total ? (item.total / total) * 100 : 0,
            color: generoColores.value[item.genero],
          }))
          return { edad, total, segmentos }
        })
    })

    const cargarDashboard = async () => {
      loading.value = true
      error.value = ''
      try {
        const [
          matriculasResponse,
          cursosResponse,
          edadResponse,
          matriculasMesResponse,
          promedioMatriculasResponse,
          promedioMatriculasHoraResponse,
          matriculasCanalResponse,
        ] =
          await Promise.all([
          axios.get('/api/dashboard/matriculas', {
            params: {
              fecha_inicio: fechaInicio.value,
              fecha_fin: fechaFin.value,
            },
          }),
          axios.get('/api/dashboard/cursos-mas-matriculados', {
            params: {
              fecha_inicio: fechaInicio.value,
              fecha_fin: fechaFin.value,
              limite: 6,
            },
          }),
          axios.get('/api/dashboard/alumnos-edad-sexo'),
          axios.get('/api/dashboard/matriculas-por-mes', {
            params: {},
          }),
          axios.get('/api/dashboard/matriculas-promedio-dia', {
            params: {
              fecha_inicio: fechaInicio.value,
              fecha_fin: fechaFin.value,
            },
          }),
          axios.get('/api/dashboard/matriculas-promedio-hora', {
            params: {
              fecha_inicio: fechaInicio.value,
              fecha_fin: fechaFin.value,
            },
          }),
          axios.get('/api/dashboard/matriculas-por-canal', {
            params: {
              fecha_inicio: fechaInicio.value,
              fecha_fin: fechaFin.value,
            },
          }),
        ])

        matriculasDetalle.value = matriculasResponse.data.detalle || []
        totalMatriculas.value = matriculasResponse.data.total || 0

        const categorias = cursosResponse.data.categorias || []
        const maxCursos = Math.max(...categorias.map((item) => item.total), 0)
        cursosMasMatriculados.value = categorias.map((curso) => ({
          ...curso,
          porcentaje: maxCursos ? (curso.total / maxCursos) * 100 : 0,
        }))

        alumnosEdadSexo.value = edadResponse.data.estadisticas || []
        matriculasPorMes.value = matriculasMesResponse.data.detalle || []
        promedioMatriculasPorDia.value = promedioMatriculasResponse.data.total_por_dia || []
        promedioMatriculasPorHora.value =
          promedioMatriculasHoraResponse.data.total_por_hora || []
        matriculasPorCanal.value = matriculasCanalResponse.data.detalle || []
      } catch (err) {
        console.error('Error cargando dashboard', err)
        error.value = 'No se pudo cargar el dashboard. Intenta nuevamente.'
      } finally {
        loading.value = false
      }
    }

    const applyChartTheme = () => {
      const root = chartRoot.value
      const chart = chartInstance.value
      const { xAxis, yAxis } = chartAxes.value
      if (!root || !chart || !xAxis || !yAxis) return

      const textColor = isDark.value ? am5.color(0xffffff) : am5.color(0x424242)
      const gridColor = isDark.value ? am5.color(0x4b5563) : am5.color(0xe0e0e0)
      const backgroundColor = isDark.value ? am5.color(0x121212) : am5.color(0xffffff)

      xAxis.get('renderer').labels.template.setAll({ fill: textColor })
      yAxis.get('renderer').labels.template.setAll({ fill: textColor })
      xAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })
      yAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })

      chart.set(
        'background',
        am5.Rectangle.new(root, {
          fill: backgroundColor,
          fillOpacity: 1,
        })
      )
    }

    const applyRangoTheme = () => {
      const root = rangoRoot.value
      const chart = rangoInstance.value
      const { xAxis, yAxis } = rangoAxes.value
      if (!root || !chart || !xAxis || !yAxis) return

      const textColor = isDark.value ? am5.color(0xffffff) : am5.color(0x424242)
      const gridColor = isDark.value ? am5.color(0x4b5563) : am5.color(0xe0e0e0)
      const backgroundColor = isDark.value ? am5.color(0x121212) : am5.color(0xffffff)

      xAxis.get('renderer').labels.template.setAll({ fill: textColor })
      yAxis.get('renderer').labels.template.setAll({ fill: textColor })
      xAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })
      yAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })

      chart.set(
        'background',
        am5.Rectangle.new(root, {
          fill: backgroundColor,
          fillOpacity: 1,
        })
      )
    }

    const applyPromedioTheme = () => {
      const root = promedioRoot.value
      const chart = promedioInstance.value
      const { xAxis, yAxis } = promedioAxes.value
      if (!root || !chart || !xAxis || !yAxis) return

      const textColor = isDark.value ? am5.color(0xffffff) : am5.color(0x424242)
      const gridColor = isDark.value ? am5.color(0x4b5563) : am5.color(0xe0e0e0)
      const backgroundColor = isDark.value ? am5.color(0x121212) : am5.color(0xffffff)

      xAxis.get('renderer').labels.template.setAll({ fill: textColor })
      yAxis.get('renderer').labels.template.setAll({ fill: textColor })
      xAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })
      yAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })

      chart.set(
        'background',
        am5.Rectangle.new(root, {
          fill: backgroundColor,
          fillOpacity: 1,
        })
      )
    }

    const applyPromedioHoraTheme = () => {
      const root = promedioHoraRoot.value
      const chart = promedioHoraInstance.value
      const { xAxis, yAxis } = promedioHoraAxes.value
      if (!root || !chart || !xAxis || !yAxis) return

      const textColor = isDark.value ? am5.color(0xffffff) : am5.color(0x424242)
      const gridColor = isDark.value ? am5.color(0x4b5563) : am5.color(0xe0e0e0)
      const backgroundColor = isDark.value ? am5.color(0x121212) : am5.color(0xffffff)

      xAxis.get('renderer').labels.template.setAll({ fill: textColor })
      yAxis.get('renderer').labels.template.setAll({ fill: textColor })
      xAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })
      yAxis.get('renderer').grid.template.setAll({ stroke: gridColor, strokeOpacity: 0.6 })

      chart.set(
        'background',
        am5.Rectangle.new(root, {
          fill: backgroundColor,
          fillOpacity: 1,
        })
      )
    }

    const initChart = async () => {
      await nextTick()
      if (chartRoot.value) return
      if (!(matriculasMesChart.value instanceof HTMLElement)) return

      const root = am5.Root.new(matriculasMesChart.value)
      chartRoot.value = root
      root.setThemes([am5themes_Animated.new(root)])

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: 'panX',
          wheelY: 'zoomX',
          pinchZoomX: true,
          paddingLeft: 0,
        })
      )
      chartInstance.value = chart

      const cursor = chart.set(
        'cursor',
        am5xy.XYCursor.new(root, {
          behavior: 'none',
        })
      )
      cursor.lineY.set('visible', false)

      const xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          maxDeviation: 0.2,
          baseInterval: {
            timeUnit: 'month',
            count: 1,
          },
          renderer: am5xy.AxisRendererX.new(root, {
            minorGridEnabled: true,
          }),
          tooltip: am5.Tooltip.new(root, {}),
        })
      )

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {
            pan: 'zoom',
          }),
        })
      )
      chartAxes.value = { xAxis, yAxis }

      const series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: 'Matrículas',
          xAxis,
          yAxis,
          valueYField: 'value',
          valueXField: 'date',
          stroke: am5.color(BRAND_PRIMARY),
          fill: am5.color(BRAND_PRIMARY),
          tooltip: am5.Tooltip.new(root, {
            labelText: '{valueY}',
          }),
        })
      )
      series.strokes.template.setAll({ strokeWidth: 2, stroke: am5.color(BRAND_PRIMARY) })
      series.bullets.push(() =>
        am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 4,
            fill: am5.color(BRAND_PRIMARY),
            stroke: am5.color(BRAND_PRIMARY),
          }),
        })
      )
      chartSeries.value = series

      chart.set(
        'scrollbarX',
        am5.Scrollbar.new(root, {
          orientation: 'horizontal',
        })
      )

      applyChartTheme()
      series.appear(1000)
      chart.appear(1000, 100)
    }

    const initRangoChart = async () => {
      await nextTick()
      if (rangoRoot.value) return
      if (!(matriculasRangoChart.value instanceof HTMLElement)) return

      const root = am5.Root.new(matriculasRangoChart.value)
      rangoRoot.value = root
      root.setThemes([am5themes_Animated.new(root)])

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: 'panX',
          wheelY: 'zoomX',
          pinchZoomX: true,
          paddingLeft: 0,
        })
      )
      rangoInstance.value = chart

      const cursor = chart.set(
        'cursor',
        am5xy.XYCursor.new(root, {
          behavior: 'none',
        })
      )
      cursor.lineY.set('visible', false)

      const xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          maxDeviation: 0.2,
          baseInterval: {
            timeUnit: 'day',
            count: 1,
          },
          renderer: am5xy.AxisRendererX.new(root, {
            minorGridEnabled: true,
          }),
          tooltip: am5.Tooltip.new(root, {}),
        })
      )

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {
            pan: 'zoom',
          }),
        })
      )
      rangoAxes.value = { xAxis, yAxis }

      const series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: 'Matrículas',
          xAxis,
          yAxis,
          valueYField: 'value',
          valueXField: 'date',
          stroke: am5.color(BRAND_PRIMARY),
          fill: am5.color(BRAND_PRIMARY),
          tooltip: am5.Tooltip.new(root, {
            labelText: '{valueY}',
          }),
        })
      )
      series.strokes.template.setAll({ strokeWidth: 2, stroke: am5.color(BRAND_PRIMARY) })
      series.bullets.push(() =>
        am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 4,
            fill: am5.color(BRAND_PRIMARY),
            stroke: am5.color(BRAND_PRIMARY),
          }),
        })
      )
      rangoSeries.value = series

      chart.set(
        'scrollbarX',
        am5.Scrollbar.new(root, {
          orientation: 'horizontal',
        })
      )

      applyRangoTheme()
      series.appear(1000)
      chart.appear(1000, 100)
    }

    const initPromedioChart = async () => {
      await nextTick()
      if (promedioRoot.value) return
      if (!(promedioMatriculasChart.value instanceof HTMLElement)) return

      const root = am5.Root.new(promedioMatriculasChart.value)
      promedioRoot.value = root

      const minorLabelTheme = am5.Theme.new(root)
      minorLabelTheme.rule('AxisLabel', ['minor']).setAll({
        dy: 1,
      })

      root.setThemes([
        am5themes_Animated.new(root),
        minorLabelTheme,
        am5themes_Responsive.new(root),
      ])

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: 'panX',
          wheelY: 'zoomX',
          paddingLeft: 0,
        })
      )
      promedioInstance.value = chart

      const cursor = chart.set(
        'cursor',
        am5xy.XYCursor.new(root, {
          behavior: 'zoomX',
        })
      )
      cursor.lineY.set('visible', false)

      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: 'dia',
          renderer: am5xy.AxisRendererX.new(root, {
            minorGridEnabled: true,
            minorLabelsEnabled: true,
          }),
          tooltip: am5.Tooltip.new(root, {}),
        })
      )

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      )
      promedioAxes.value = { xAxis, yAxis }

      const series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: 'Total',
          xAxis,
          yAxis,
          valueYField: 'total',
          categoryXField: 'dia',
          fill: am5.color(BRAND_PRIMARY),
          stroke: am5.color(BRAND_PRIMARY),
          tooltip: am5.Tooltip.new(root, {
            labelText: 'Total: {valueY}',
          }),
        })
      )
      series.columns.template.setAll({
        strokeOpacity: 0,
        fill: am5.color(BRAND_PRIMARY),
        cornerRadiusTL: 4,
        cornerRadiusTR: 4,
      })
      promedioSeries.value = series

      chart.set(
        'scrollbarX',
        am5.Scrollbar.new(root, {
          orientation: 'horizontal',
        })
      )

      applyPromedioTheme()
      series.appear(1000)
      chart.appear(1000, 100)
    }

    const initPromedioHoraChart = async () => {
      await nextTick()
      if (promedioHoraRoot.value) return
      if (!(promedioMatriculasHoraChart.value instanceof HTMLElement)) return

      const root = am5.Root.new(promedioMatriculasHoraChart.value)
      promedioHoraRoot.value = root

      const minorLabelTheme = am5.Theme.new(root)
      minorLabelTheme.rule('AxisLabel', ['minor']).setAll({
        dy: 1,
      })

      root.setThemes([
        am5themes_Animated.new(root),
        minorLabelTheme,
        am5themes_Responsive.new(root),
      ])

      const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: false,
          panY: false,
          wheelX: 'panX',
          wheelY: 'zoomX',
          paddingLeft: 0,
        })
      )
      promedioHoraInstance.value = chart

      const cursor = chart.set(
        'cursor',
        am5xy.XYCursor.new(root, {
          behavior: 'zoomX',
        })
      )
      cursor.lineY.set('visible', false)

      const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
          categoryField: 'horaLabel',
          renderer: am5xy.AxisRendererX.new(root, {
            minorGridEnabled: true,
            minorLabelsEnabled: true,
          }),
          tooltip: am5.Tooltip.new(root, {}),
        })
      )

      const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {}),
        })
      )
      promedioHoraAxes.value = { xAxis, yAxis }

      const series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name: 'Total',
          xAxis,
          yAxis,
          valueYField: 'total',
          categoryXField: 'horaLabel',
          fill: am5.color(BRAND_PRIMARY),
          stroke: am5.color(BRAND_PRIMARY),
          tooltip: am5.Tooltip.new(root, {
            labelText: 'Total: {valueY}',
          }),
        })
      )
      series.columns.template.setAll({
        strokeOpacity: 0,
        fill: am5.color(BRAND_PRIMARY),
        cornerRadiusTL: 4,
        cornerRadiusTR: 4,
      })
      promedioHoraSeries.value = series

      chart.set(
        'scrollbarX',
        am5.Scrollbar.new(root, {
          orientation: 'horizontal',
        })
      )

      applyPromedioHoraTheme()
      series.appear(1000)
      chart.appear(1000, 100)
    }

    const applyCanalTheme = () => {
      const root = canalRoot.value
      if (!root || !canalSeries.value) return

      const textColor = isDark.value ? am5.color(0xffffff) : am5.color(0x424242)
      canalSeries.value.labels.template.setAll({ fill: textColor })
    }

    const initCanalChart = async () => {
      await nextTick()
      if (canalRoot.value) return
      if (!(matriculasCanalChart.value instanceof HTMLElement)) return

      const root = am5.Root.new(matriculasCanalChart.value)
      canalRoot.value = root
      root.setThemes([am5themes_Animated.new(root)])

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          innerRadius: am5.percent(40),
        })
      )
      canalInstance.value = chart

      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          name: 'Canales',
          valueField: 'total',
          categoryField: 'canal',
        })
      )
      series.labels.template.setAll({
        text: '{category}: {value}',
        fontSize: 12,
      })
      series.slices.template.setAll({
        tooltipText: '{category}: {value} ({valuePercentTotal.formatNumber("0.0")}%)',
      })
      series.set('colors', am5.ColorSet.new(root, {
        colors: [
          am5.color(BRAND_PRIMARY),
          am5.color(BRAND_SECONDARY),
          am5.color(0xfb8c00),
          am5.color(0xf57f17),
          am5.color(0x4caf50),
          am5.color(0x2196f3),
          am5.color(0x9c27b0),
          am5.color(0xe91e63),
          am5.color(0x607d8b),
        ],
      }))
      canalSeries.value = series

      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          marginTop: 15,
          marginBottom: 15,
        })
      )
      legend.data.setAll(series.dataItems)
      canalLegend.value = legend

      applyCanalTheme()
      series.appear(1000, 100)
    }

    const updateCanalData = async () => {
      if (!matriculasPorCanal.value.length) {
        if (canalSeries.value) {
          canalSeries.value.data.setAll([])
        }
        return
      }

      await initCanalChart()
      if (!canalSeries.value) return

      const canalData = matriculasPorCanal.value.map((item) => ({
        canal: item.canal,
        total: Number(item.total || 0),
      }))

      canalSeries.value.data.setAll(canalData)
      if (canalLegend.value) {
        canalLegend.value.data.setAll(canalSeries.value.dataItems)
      }
    }

    const updateChartData = async () => {
      if (!matriculasPorMes.value.length) {
        if (chartSeries.value) {
          chartSeries.value.data.setAll([])
        }
        return
      }

      await initChart()
      if (!chartSeries.value) return

      const chartData = matriculasPorMes.value.map((item) => ({
        date: new Date(item.anio, item.mes - 1, 1).getTime(),
        value: item.total,
      }))

      chartSeries.value.data.setAll(chartData)
    }

    const updateRangoData = async () => {
      await initRangoChart()
      if (!rangoSeries.value) return

      if (!fechaInicio.value || !fechaFin.value) {
        rangoSeries.value.data.setAll([])
        return
      }

      const totalesPorFecha = matriculasDetalle.value.reduce((acc, item) => {
        const key = String(item.fecha).slice(0, 10)
        acc[key] = (acc[key] || 0) + Number(item.total || 0)
        return acc
      }, {})

      const [yi, mi, di] = fechaInicio.value.split('-').map(Number)
      const [yf, mf, df] = fechaFin.value.split('-').map(Number)
      const cursor = new Date(yi, mi - 1, di)
      const end = new Date(yf, mf - 1, df)

      const rangoData = []
      while (cursor <= end) {
        const key = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, '0')}-${String(cursor.getDate()).padStart(2, '0')}`
        rangoData.push({
          date: cursor.getTime(),
          value: totalesPorFecha[key] || 0,
        })
        cursor.setDate(cursor.getDate() + 1)
      }

      rangoSeries.value.data.setAll(rangoData)
    }

    const updatePromedioData = async () => {
      if (!promedioMatriculasPorDia.value.length) {
        if (promedioSeries.value) {
          promedioSeries.value.data.setAll([])
        }
        return
      }

      await initPromedioChart()
      if (!promedioSeries.value) return

      const promedioData = [...promedioMatriculasPorDia.value]
        .sort((a, b) => (a.dia_semana_num ?? 0) - (b.dia_semana_num ?? 0))
        .map((item) => ({
          dia_semana_num: item.dia_semana_num,
          dia: item.dia,
          total: item.total,
        }))

      promedioSeries.value.data.setAll(promedioData)
      if (promedioAxes.value.xAxis) {
        promedioAxes.value.xAxis.data.setAll(promedioData)
      }
    }

    const updatePromedioHoraData = async () => {
      if (!promedioMatriculasPorHora.value.length) {
        if (promedioHoraSeries.value) {
          promedioHoraSeries.value.data.setAll([])
        }
        return
      }

      await initPromedioHoraChart()
      if (!promedioHoraSeries.value) return

      const promedioHoraData = [...promedioMatriculasPorHora.value]
        .sort((a, b) => (a.hora ?? 0) - (b.hora ?? 0))
        .map((item) => ({
          hora: item.hora,
          horaLabel: `${String(item.hora).padStart(2, '0')}:00`,
          total: item.total,
        }))

      promedioHoraSeries.value.data.setAll(promedioHoraData)
      if (promedioHoraAxes.value.xAxis) {
        promedioHoraAxes.value.xAxis.data.setAll(promedioHoraData)
      }
    }

    watch(
      matriculasPorMes,
      () => {
        updateChartData()
      },
      { flush: 'post' }
    )

    watch(
      matriculasDetalle,
      () => {
        updateRangoData()
      },
      { flush: 'post' }
    )

    watch(
      promedioMatriculasPorDia,
      () => {
        updatePromedioData()
      },
      { flush: 'post' }
    )

    watch(
      promedioMatriculasPorHora,
      () => {
        updatePromedioHoraData()
      },
      { flush: 'post' }
    )

    watch(
      matriculasPorCanal,
      () => {
        updateCanalData()
      },
      { flush: 'post' }
    )

    watch(
      isDark,
      () => {
        applyChartTheme()
        applyRangoTheme()
        applyPromedioTheme()
        applyPromedioHoraTheme()
        applyCanalTheme()
      },
      { flush: 'post' }
    )

    onMounted(() => {
      cargarDashboard()
      initChart()
      initRangoChart()
      initPromedioChart()
      initPromedioHoraChart()
      initCanalChart()
    })

    onBeforeUnmount(() => {
      if (chartRoot.value) {
        chartRoot.value.dispose()
        chartRoot.value = null
        chartInstance.value = null
        chartSeries.value = null
        chartAxes.value = { xAxis: null, yAxis: null }
      }
      if (rangoRoot.value) {
        rangoRoot.value.dispose()
        rangoRoot.value = null
        rangoInstance.value = null
        rangoSeries.value = null
        rangoAxes.value = { xAxis: null, yAxis: null }
      }
      if (promedioRoot.value) {
        promedioRoot.value.dispose()
        promedioRoot.value = null
        promedioInstance.value = null
        promedioSeries.value = null
        promedioAxes.value = { xAxis: null, yAxis: null }
      }
      if (promedioHoraRoot.value) {
        promedioHoraRoot.value.dispose()
        promedioHoraRoot.value = null
        promedioHoraInstance.value = null
        promedioHoraSeries.value = null
        promedioHoraAxes.value = { xAxis: null, yAxis: null }
      }
      if (canalRoot.value) {
        canalRoot.value.dispose()
        canalRoot.value = null
        canalInstance.value = null
        canalSeries.value = null
        canalLegend.value = null
      }
    })

    return {
      loading,
      error,
      fechaInicio,
      fechaFin,
      matriculasDetalle,
      matriculasPorMes,
      matriculasMesChart,
      totalMatriculas,
      cursosMasMatriculados,
      alumnosEdadSexo,
      matriculasRangoChart,
      promedioMatriculasPorDia,
      promedioMatriculasChart,
      promedioMatriculasPorHora,
      promedioMatriculasHoraChart,
      matriculasPorCanal,
      matriculasCanalChart,
      edadesPorGenero,
      generoColores,
      isDark,
      cargarDashboard,
    }
  },
})
</script>

<style scoped>
.gap-3 {
  gap: 12px;
}

.bar-list,
.stacked-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bar-row,
.stacked-row {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) 2fr auto;
  align-items: center;
  gap: 12px;
}

.bar-label {
  font-size: 0.85rem;
  font-weight: 500;
}

.bar-track {
  background: rgba(242, 205, 20, 0.18);
  border-radius: 999px;
  height: 10px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: #f2cd14;
  border-radius: 999px;
}

.stacked-track {
  display: flex;
  height: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.08);
}

.stacked-segment {
  height: 100%;
}

.chart-panel {
  min-height: 320px;
}

.amchart {
  width: 100%;
  height: 320px;
}

.amchart-pie {
  height: 420px;
}

.bar-value {
  font-weight: 600;
  font-size: 0.85rem;
  text-align: right;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

@media (max-width: 600px) {
  .bar-row,
  .stacked-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .bar-value {
    text-align: left;
  }
}
</style>
